'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var I18n = require('../../global/i18n');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e['default'] : e; }

var I18n__default = /*#__PURE__*/_interopDefaultLegacy(I18n);

/*= =============== signup-header.js ================*/

/**
 * Determines the heading to be used for the signup modal
 */

function SignupHeader() {
  return I18n__default.t('signup.custom_header') ? I18n__default.t('signup.custom_header') : I18n__default.t('signup.header');
}

exports.default = SignupHeader;
